export enum EventType {
  Practice = 1,
  LeagueMatch = 2,
  Tournament = 3,
  Other = 4
}